module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/HowToFileClaimSection/fill-in-form-0a5dd6c3738d0cc48eb4cef5d79db004.png";